import { LocalesMenuButton } from "@/components/admin/locales-menu-button";
import { MobileRefreshButton } from "./MobileRefreshButton";

const MobileHeader = ({ children }: { children: React.ReactNode }) => {
  return (
    <header className="fixed top-0 left-0 right-0 z-10 bg-secondary h-14 px-4 w-full flex justify-between items-center">
      {children}
      {/* MobileLayout never mounts the desktop <Header>, so without this the
          switcher there would leave phone users no way to change language. */}
      <div className="flex items-center">
        <LocalesMenuButton />
        <MobileRefreshButton />
      </div>
    </header>
  );
};

export default MobileHeader;
